module.exports = __webpack_public_path__ + "img/01-trpg-material2021.4fac619f.png";